import React from 'react';

export default React.createContext({ top: 0, bottom: 1056, scrollTop: 0 });
